export const monthSelectList = { options: ['01', '02', '03', '04', '05', '06', '07', '08', '09'] };
export const CARD_MAX_SIZE = 5;
export const CARD_MAX_MESSAGE = `追加できるカードの枚数は${CARD_MAX_SIZE}枚までのため新規カードの追加はできません。`;
